// extracted by css-extract-rspack-plugin
export default {"searchBar":"XG2DWJshfckBYMto"};